import React, {useEffect, useState} from 'react'
import { Formik, Field, Form, FieldArray } from 'formik';
import { getImages } from '../const';

export const AdminAccordionItem = ({  getVehicleData, vehicleData, priceFormatter, inventoryManage }) => {
      
    useEffect(() => {
        getVehicleData();
    },[]);

    const [inventoryManageData,setInventoryManageData] = useState({});

    useEffect(() => {
        if(vehicleData) {
            const inventory_manage_data = vehicleData.reduce((acc, item) => {
                acc[item.vin] = item.inventory_manage; // Or acc[key] = item; if you want the whole item
                return acc;
            }, {});
            console.log(inventory_manage_data);
            setInventoryManageData(inventory_manage_data);
        }
    },[vehicleData]);

    const updateInventoryManage = (e,vin,field,checkbox=false) => {

        setInventoryManageData((prev) => ({
            ...prev,
            [vin] : {...prev[vin],[field]:checkbox ? e.target.checked : e.target.value}
        }));

        inventoryManage({...inventoryManageData[vin],[field]:checkbox ? e.target.checked : e.target.value,["vin"]:vin})
    }

    return (
        <>
            <div className='d-flex align-items-center justify-content-between'>
                <div className='sm-title'>Select up to 6 vehicles <img className='ms-2' src={getImages('info-icon1.png')}/></div>
                <div className='xs-title font-14'>{Object.values(inventoryManageData).filter(item => item.lease_special).length} of 6 Selected</div>
            </div>
            <div className="accordion ue-accordion" id="accordionExample">
                <table className='w-100 custom-table'>
                    <thead>
                        <tr>
                            <th style={{ width: '4%' }}>&nbsp;</th>
                            <th style={{ width: '31%' }}>Vehicle</th>
                            <th style={{ width: '15%' }} className='text-center'>Price</th>
                            <th style={{ width: '15%' }} className='text-center'>Miles</th>
                            <th style={{ width: '15%' }} className='text-center'>Stock #</th>
                            <th style={{ width: '20%' }} className='text-end'>&nbsp;</th>
                        </tr>
                    </thead>
                </table>
                {vehicleData && vehicleData.map((item, index) => {
                    const headingId = `heading${index}`;
                    const collapseId = `collapse${index}`;
                    const isExpanded = item.show ? 'true' : 'false';
                    const buttonClass = item.show ? 'accordion-button' : 'accordion-button collapsed';
                    const collapseClass = item.show ? 'accordion-collapse collapse show' : 'accordion-collapse collapse';
                    const isSelected = item.inventory_manage.lease_special ? 'selected' : '';
                    // console.log("item.id", item.id)
                    return (
                        <div className={`accordion-item ${isSelected}`} key={index}>
                            <table className='w-100 custom-table'>
                                <tbody>
                                    <tr>
                                        <td style={{ width: '4%' }}>
                                            <h2 className="accordion-header" id={headingId}>
                                                <button
                                                    className={buttonClass}
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target={`#${collapseId}`}
                                                    aria-expanded={isExpanded}
                                                    aria-controls={collapseId}
                                                >
                                                    <img src={getImages('arrow-close.svg')} alt='icon' />
                                                </button>
                                            </h2>
                                        </td>
                                        <td style={{ width: '31%' }} className='text-start'>
                                            <div className='xs-title text-blue'>{item.vehicle_name}</div>
                                        </td>
                                        <td style={{ width: '15%' }} className='text-center'><div className='xs-title'>{priceFormatter(item.price,true)}</div></td>
                                        <td style={{ width: '15%' }} className='text-center'>{priceFormatter(item.mileage)}</td>
                                        <td style={{ width: '15%' }} className='text-center'>{item.stockno}</td>
                                        <td style={{ width: '20%' }} className='text-end pe-4'>
                                            <div className='d-flex'>
                                                {inventoryManageData && item.vin in inventoryManageData && <div className="custom-checkbox dash-checkbox ms-auto me-2">
                                                    <input
                                                        type='checkbox'
                                                        id={`chk_${index}`}
                                                        checked={inventoryManageData[item.vin].lease_special}
                                                        onChange={(e) => {updateInventoryManage(e,item.vin,'lease_special',true)}}
                                                    />
                                                    <label htmlFor={`chk_${index}`} className="w-100"></label>
                                                </div>}
                                                <div>
                                                    <button type='button' className='btn-menu-icon text-uppercase'>
                                                        <img src={getImages('menu-icon.png')}/>
                                                    </button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div
                                id={collapseId}
                                className={collapseClass}
                                aria-labelledby={headingId}
                                data-bs-parent="#accordionExample"
                            >
                                <div
                                    className="accordion-body"
                                >
                                   <div className='row'>
                                        {inventoryManageData && item.vin in inventoryManageData && <div className='col-md-2 mb-3'>
                                            <div className='cs-label'>Price per month</div>
                                            <input type='number' className='form-control'
                                                onChange={(e) => {updateInventoryManage(e,item.vin,'price_per_month')}}
                                                value={inventoryManageData[item.vin].price_per_month}
                                            />
                                        </div>}
                                        {inventoryManageData && item.vin in inventoryManageData && <div className='col-md-10 mb-3'>
                                            <div className='cs-label'>Description</div>
                                            <input type='text' className='form-control'
                                                onChange={(e) => {updateInventoryManage(e,item.vin,'description')}}
                                                value={inventoryManageData[item.vin].description}
                                            />
                                            </div>}
                                        {inventoryManageData && item.vin in inventoryManageData && <div className='col-12 mb-3'>
                                            <div className='cs-label'>Disclaimer</div>
                                            <textarea className='form-control h-100px'
                                                onChange={(e) => {updateInventoryManage(e,item.vin,'disclaimer')}}
                                                value={inventoryManageData[item.vin].disclaimer}
                                            />
                                        </div>}
                                        {inventoryManageData && item.vin in inventoryManageData && <div className='col-md-2 mb-3'>
                                            <div className='cs-label'>Backup Price</div>
                                            <input type='number' className='form-control'
                                                onChange={(e) => {updateInventoryManage(e,item.vin,'backup_price')}}
                                                value={inventoryManageData[item.vin].backup_price}
                                            />
                                        </div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </>
    )
}
